import { useState, useRef, useEffect } from 'react';
import { useWizardNavigation } from './use-wizard';
import { StepContainer } from './step-container';

function StepPartner() {
  const { searchParams, goNext, goBack, currentIndex, totalSteps } =
    useWizardNavigation();
  const [value, setValue] = useState(searchParams.get('companero') || '');
  const inputRef = useRef<HTMLInputElement>(null);

  const isValid = value.trim().length >= 3;

  const handleNext = () => {
    if (isValid) goNext({ companero: value.trim() });
  };

  return (
    <StepContainer
      stepIndex={currentIndex}
      totalSteps={totalSteps}
      title="¿Cuál es el nombre de tu compañero?"
      onBack={goBack}
      onNext={handleNext}
      nextDisabled={!isValid}
    >
      <input
        ref={inputRef}
        autoFocus
        type="text"
        value={value}
        onChange={(e) => {
          const v = e.target.value.replace(/(^|\s)\S/g, (c) => c.toUpperCase());
          setValue(v);
        }}
        placeholder="Ej: María López"
        autoComplete="name"
        className="w-full text-lg md:text-xl p-4 border-2 border-gray-200 rounded-xl focus:border-primary focus:ring-4 focus:ring-primary/10 outline-none transition-all"
        onKeyDown={(e) => e.key === 'Enter' && isValid && handleNext()}
      />
    </StepContainer>
  );
}

export const route = {
  path: 'companero',
  element: <StepPartner />,
};
